import "@tanstack/react-table";
import type { FilterFn, RowData } from "@tanstack/react-table";

declare module "@tanstack/react-table" {
	interface ColumnMeta<TData extends RowData, TValue> {
		headerFilterType?: "checkbox";
		noTruncate?: boolean;
		centerItems?: boolean;
		fitContent?: boolean;
		csvKey?: string;
		csvLabel?: string;
		csvFormatter?: (value: unknown) => string;
		period?: TValue;
	}
}

export const checkboxFilter: FilterFn<any> = (row, columnId, filterValue: string[]) => {
	if (!filterValue || filterValue.length === 0) return true;
	return filterValue.includes(String(row.getValue(columnId)));
};

export const arrayCheckboxFilter: FilterFn<any> = (row, columnId, filterValue: string[]) => {
	if (!filterValue || filterValue.length === 0) return true;
	const cellValues = row.getValue<string[]>(columnId);
	return filterValue.some((v) => cellValues?.includes(v));
};
